import React, { Component } from "react";
import ProgressBar from "./ProgressBar";

class Languages extends Component {
  state = {
    languages: [
      { id: 1, value: "JavaScript", xp: 1 },
      { id: 2, value: "Css", xp: 1.5 },
      { id: 3, value: "Html", xp: 1.8 },
    ],
    frameworks: [
      { id: 1, value: "React", xp: 0.5 },
      { id: 2, value: "Node", xp: 1 },
      { id: 3, value: "Sass", xp: 0.5 },
      { id: 4, value: "Express", xp: 1 },
    ],
  };

  render() {
    let { languages, frameworks } = this.state;
    return (
      <div className="languagesFrameworks">
        <ProgressBar
          languages={languages}
          className="languagesDisplay"
          title="languages"
        />
        <ProgressBar
          languages={frameworks}
          className="frameworksDisplay"
          title="frameworks & bibliothèques"
        />
      </div>
    );
  }
}

export default Languages;
